module.exports = __webpack_public_path__ + "static/media/image02.6cdcc990.png";